import React, { useState } from "react";
import { } from "react-router";

import "bootstrap/dist/css/bootstrap.min.css";
//import logo from "./logo_clean_verify.png"
import "../../../App.css";




const SaveButton = ({disabled,children}) => {

  const [loading,setLoading] = useState(false);
 
  function handleClick(){

    console.log('save button clicked...waiting for onSubmit event to trigger... ')
    setLoading(true);
    
   // handleSubmit();
 }

return (   
  
        <button  type="submit" id="submit" 
                className={`m-1 p-1 rounded-md ring-1 ring-white 
                  flex flex-row                  
                  bg-gradient-to-b from-sky-200 to-sky-600 
                    hover:shadow-lg hover:ring-lime-400  hover:text-lime-400 
                    focus:ring-red-400
                  transition-all ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 hover:duration-150
                  disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500
                    `
                                   
                } 
                disabled={disabled} onClick={handleClick}>
          {!loading ? (
            `✅`         
          ):(
              <svg className="animate-spin h-4 w-4 mt-1 fill-slate-700" viewBox="0 0 24 24">
                                <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
                                <path d="M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z" />
              </svg>
          )}
          <span className="mx-1  font-semibold text-sm text-white">{children}</span>
          
          
          
  
        </button>
  
      );
};

export default SaveButton;
